import { Box, Grid2 as Grid } from '@mui/material';
import React, { useState } from 'react';
import { StripeCheckoutForm } from './CheckoutForm';
import { GetPackage } from './GetPackage';
import { Intro } from './Intro';
import { PackagePerks } from './PackagePerks';
import { PipelineSummary } from './PipelineSummary';
export const ReviewGrants = () => {
    const [showCheckoutForm, setShowCheckoutForm] = useState(false);
    return (React.createElement(Box, { width: "100%" },
        showCheckoutForm && React.createElement(StripeCheckoutForm, null),
        !showCheckoutForm && (React.createElement(Box, { p: 3, my: 4, mx: "auto", width: "100%", maxWidth: "880px" },
            React.createElement(Intro, null),
            React.createElement(Grid, { container: true, spacing: 3, sx: { my: 3 } },
                React.createElement(Grid, { size: { xs: 12, md: 6 } },
                    React.createElement(PipelineSummary, null)),
                React.createElement(Grid, { size: { xs: 12, md: 6 } },
                    React.createElement(GetPackage, { toggleCheckout: setShowCheckoutForm }))))),
        React.createElement(PackagePerks, null)));
};
